var help = [
    {
        name: 'helpCenter',
        path: '/help-center',
        component: function () { return import('../views/help-center.vue'); },
    },
    {
        name: 'helpCenterFeedback',
        path: '/help-center/feedback',
        component: function () { return import('../components/help-center/help-center-feedback.vue'); },
    },
    {
        name: 'helpCenterQuestions',
        path: '/help-center/questions',
        component: function () { return import('../components/help-center/help-center-questions.vue'); },
    },
];
export default help;
